import { DashBoardInput } from "@root/components/dashboard";
import { getThreadPID } from "@root/store/selectors/entities/thread";
import { WEB_PROJECTS } from "@root/webConstants";
import { useSelector } from "react-redux";
import { Box, Flex } from "@chakra-ui/react";
import Select from "react-select";
import { CustonButtom } from "@root/components/common/button/customButton";
import { CommonFooter } from "@root/components/auth/commonFooter";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import UploadImages from "./ChatImages";
import { SmallText } from "@root/components/common/text/SmallText";
import useProjectsDashboard from "@root/hooks/useProjectsDashboard";
import { getSelectedModel } from "@root/store/selectors/entities/thread";

function ChatContainerBottomSide({
  fileContainerRef,
  submitHandler,
  onChangehandler,
  input,
  loading,
  setInput,
  hideInputs,
  riskCheckerInputRef,
  onRiskcheckSelectFile,
  width = "100%",
}: any) {
  const { t } = useTranslation("common");
  const pid = useSelector(getThreadPID);
  const navigate = useNavigate();

  const selectedModel = useSelector(getSelectedModel);
  const { onModelChange, modelOptions } = useProjectsDashboard();
  if (hideInputs) {
    return (
      <Box pt={"16px"}>
        <CustonButtom
          onClick={() => navigate("/")}
          text={t("dashboard.getStarted")}
          width="fit-content"
          height="55px"
          mx={"auto"}
          mb={"16px"}
        />
        <CommonFooter />
      </Box>
    );
  }

  if (pid === WEB_PROJECTS.RISK_CHECKER.id) {
    return (
      <Box
        my={"24px"}
        //width={{ base: "96%", md: "80%", lg: "90%", halfxl: "1260px" }}
        //mx={"auto"}
      >
        <input
          type="file"
          ref={riskCheckerInputRef}
          style={{ display: "none" }}
          onChange={onRiskcheckSelectFile}
          accept="image/png, image/jpeg, image/jpg"
        />
      </Box>
    );
  }

  return (
    <Box
      borderRadius={"16px"}
      mb="20px"
      px={"20px"}
      width={width}
      mx="auto"
      maxWidth="100%"
      minWidth={0}
      // overflow="hidden"
    >
      <Box >
        <DashBoardInput
          fileContainerRef={fileContainerRef}
          submitHandler={submitHandler}
          onChangehandler={onChangehandler}
          input={input}
          onSubmit={submitHandler}
          loading={loading}
          setInput={setInput}
          pid={pid}
          transition="padding 0.3s ease"
        />
      </Box>
    </Box>
  );
}

export default ChatContainerBottomSide;
